import { ChangeDetectorRef, Component, OnInit, ViewChild } from '@angular/core';
import {
    FormBuilder,
    FormControl,
    FormGroup,
    Validators,
} from '@angular/forms';
import { NbDialogRef } from '@nebular/theme';
import { ProfileService } from 'src/app/services/profile.service';
import { ModelService } from 'src/app/services/model.service';
@Component({
    selector: 'app-personal',
    templateUrl: './personal.component.html',
    styleUrls: ['./personal.component.scss'],
})
export class PersonalComponent implements OnInit {
    disabled: boolean = false;
    userId: string;
    createForm: FormGroup;
    show: boolean = false;
    allow: boolean = false;
    categories: any[] = [];
    data: any[] = [];
    @ViewChild('autoInput') input;
    showField: string;
    adminS: boolean = false;
    constructor(
        protected ref: NbDialogRef<PersonalComponent>,
        private formBuilder: FormBuilder,
        private profile: ProfileService,
        private cdref: ChangeDetectorRef,
        private modelService: ModelService
    ) {}

    // _____Checkboxes functions_____
    typesOfFields: string[];
    areasOfStudy: string[];
    fieldsOfWork: string[];

    selectedFields = [];
    selectedField;
    fieldofwork: any;
    areaofstudies: any;
    fromDb = null;
    // ✅ Provide empty array as fallback
    c_field = this.fromDb || [];

    onNgModelChange($event) {
        var myArrString = JSON.stringify($event);
        // console.log(myArrString);
        this.selectedField = myArrString;
        // this.selectedFields=$event;
        // console.log(this.selectedFields);
        // this.selectedField=$event;
    }

    // _______

    ngOnInit(): void {
        this.typesOfFields = this.modelService.getSectorsOfInterest();
        this.areasOfStudy = this.modelService.getAreasOfStudy();
        this.fieldsOfWork = this.modelService.getFieldsOfWork();
        this.show = false;
        const emailPattern = /[a-z0-9._%+-]+@[a-z0-9.-]+\.[a-z]{2,4}$/;
        this.userId = JSON.parse(localStorage.getItem('user')).id;
        this.createForm = this.formBuilder.group({
            inputFirstName: new FormControl({ value: '' }, [
                Validators.required,
                Validators.minLength(2),
            ]),
            inputLastName: new FormControl({ value: '' }, [
                Validators.required,
                Validators.minLength(2),
            ]),
            inputCountry: new FormControl({ value: '' }, [
                Validators.required,
                Validators.minLength(2),
            ]),
            inputCity: new FormControl({ value: '' }, [
                Validators.required,
                Validators.minLength(2),
            ]),
            inputEmail: new FormControl({ value: '', disabled: true }, [
                Validators.required,
                Validators.pattern(emailPattern),
            ]),
            inputPhone: new FormControl({ value: '' }, [
                Validators.nullValidator,
                Validators.pattern('^[0-9]*$'),
            ]),
            inputMobile: new FormControl({ value: '' }, [
                Validators.nullValidator,
                Validators.pattern('^[0-9]*$'),
            ]),
            fieldOfWork: new FormControl({ value: '' }, [Validators.required]),
            areaOfStudies: new FormControl({ value: '' }, [
                Validators.required,
            ]),
            inputLinkedIn: new FormControl({ value: '' }, [
                Validators.nullValidator,
                Validators.pattern(
                    '(https?://)?([\\da-z.-]+)\\.([a-z.]{2,6})[/\\w .-]*/?'
                ),
            ]),
            inputTwitter: new FormControl({ value: '' }, [
                Validators.nullValidator,
                Validators.pattern(
                    '(https?://)?([\\da-z.-]+)\\.([a-z.]{2,6})[/\\w .-]*/?'
                ),
            ]),
            inputWebsite: new FormControl({ value: '' }, [
                Validators.nullValidator,
                Validators.pattern(
                    '(https?://)?([\\da-z.-]+)\\.([a-z.]{2,6})[/\\w .-]*/?'
                ),
            ]),
        });

        this.profile.get_all_user_info(this.userId).subscribe((res) => {
            if (res.length) {
                this.f.inputFirstName.setValue(res[0].firstName);
                this.f.inputLastName.setValue(res[0].lastName);
                this.f.inputCountry.setValue(res[0].country);
                this.f.inputCity.setValue(res[0].city);
                this.f.inputEmail.setValue(res[0].email);
                this.f.inputPhone.setValue(res[0].landline);
                this.f.inputMobile.setValue(res[0].mobile);
                this.f.inputLinkedIn.setValue(res[0].linkedIn);
                this.f.inputTwitter.setValue(res[0].twitter);
                this.f.inputWebsite.setValue(res[0].website);
                this.f.fieldOfWork.setValue(res[0].fieldsOfWork);
                this.f.areaOfStudies.setValue(res[0].areaOfStudies);

                // console.log(res)

                if (res[0].roles.includes('Administrator')) this.adminS = true;

                this.profile
                    .get_user_social(this.userId)
                    .subscribe((social) => {
                        this.f.inputLinkedIn.setValue(social[0].linkedIn);
                        this.f.inputTwitter.setValue(social[0].twitter);
                        this.f.inputWebsite.setValue(social[0].website);
                    });

                this.data.forEach((el) => {
                    if (el.childs.length > 0) {
                        var data = { name: el.name, childs: [] };
                        el.childs.forEach((element) => {
                            if (element.childs.length > 0) {
                                element.childs.forEach((inside) => {
                                    data.childs.push({
                                        name: inside.name,
                                        id: inside.id,
                                        marked: false,
                                    });
                                });
                            } else {
                                data.childs.push({
                                    name: element.name,
                                    id: element.id,
                                    marked: false,
                                });
                            }
                        });
                        this.categories.push(data);
                    }
                });
            }
        });
        this.checkbox();

        this.cdref.detectChanges();
    }
    // ngAfterContentChecked() {

    //   this.checkbox()

    //   this.cdref.detectChanges();

    //    }

    checkbox() {
        this.profile.get_all_user_info(this.userId).subscribe((res) => {
            var myArrString = res[0].fields;
            if(myArrString){
            this.c_field = myArrString;
            }
            // console.log(this.c_field);
        });
    }

    get f() {
        return this.createForm.controls;
    }

    close() {
        this.ref.close();
    }

    save() {
        if (this.createForm.invalid) {
            return;
        }
        const data = {
            first_name: this.f.inputFirstName.value,
            last_name: this.f.inputLastName.value,
            country: this.f.inputCountry.value,
            city: this.f.inputCity.value,
            email: this.f.inputEmail.value,
            landline: this.f.inputPhone.value,
            mobile: this.f.inputMobile.value,
            linkedIn: this.f.inputLinkedIn.value,
            twitter: this.f.inputTwitter.value,
            website: this.f.inputWebsite.value,
            fields: this.selectedField,
            area_of_studies: this.areaofstudies,
            fields_of_work: this.fieldofwork,
        };
        // console.log(data)
        this.ref.close(data);
    }

    getStatus(marked: boolean) {
        if (marked) return 'success';
        else return 'primary';
    }

    getOutline(marked: boolean) {
        if (marked) return false;
        else return true;
    }

    markedEdit(child: any) {
        this.categories.map((element) => {
            element.childs.map((el) => {
                if (el.id == child.id) return (el.marked = !el.marked);
            });
        });
        var count = 0;
        this.categories.forEach((el) => {
            el.childs.forEach((element) => {
                if (element.marked) count++;
            });
        });
        if (count > 0) this.allow = true;
        else this.allow = false;
    }

    fieldwork(event) {
        this.fieldofwork = event.value;
        // console.log(this.fieldofwork)
    }

    areastudies(event) {
        this.areaofstudies = event.value;
        // console.log(this.areaofstudies)
    }
}
